<template>
  <div class="without" style="margin-top:0px">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h1>BIENVENIDO A TRÉBOL JURÍDICO (VERSIÓN BETA)</h1>
        <h4>Sistema para la gestión y cobro de su cartera.</h4>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col text-center rounded m-3">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/LtGYHMV4JQM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <!-- <iframe class="embed-responsive-item" src="https://youtu.be/LtGYHMV4JQM" allowfullscreen></iframe> -->
        </div>
        <div class="col-md-12 text-center mt-2">
          <h4>Tutorial - Gestión de cartera.</h4>
        </div>
      </div>

      <div class="col text-center rounded m-3">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/KIL9zy3hOZU"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <!-- <iframe class="embed-responsive-item" src="https://youtu.be/KIL9zy3hOZU" allowfullscreen></iframe> -->
        </div>
        <div class="col-md-12 text-center mt-2">
          <h4>Tutorial - Análisis de cartera.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "customerdashboard",
  components: {},
  data: function() {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false
    };
  },
  created() {},
  methods: {
    getAllInfo() {
      showLoader();

      hideLoader();
    }
  }
};
</script>